import { createAuthClient } from 'better-auth/react'
import { organizationClient } from 'better-auth/client/plugins'

const baseURL = import.meta.env.VITE_API_BASE_URL || ''

export const authClient = createAuthClient({
  baseURL,
  plugins: [organizationClient()],
})

export const { signIn, signUp, signOut, useSession } = authClient
